'use client';

import { HelpEmailLink } from '@/app/components/ui';
import { HelpEmailLinkProps } from '@/app/components/ui/HelpEmailLink/HelpEmailLink';
import { useCobranded } from '@/app/contexts/CobrandedProvider';
import { config, Partner } from '@/configs/partner';

/**
 * Support-email link driven by the resolved co-brand config. Falls back to the
 * business support email when the current order isn't co-branded (or the
 * co-brand has no dedicated address yet).
 */
const HelpLink = ({ standalone, className, color }: HelpEmailLinkProps) => {
  const { config: cobrandedConfig } = useCobranded();
  const helpEmail =
    cobrandedConfig?.supportEmail ?? config[Partner.business].supportEmail;

  return (
    <HelpEmailLink
      standalone={standalone}
      helpEmail={helpEmail}
      className={className}
      color={color}
    />
  );
};

export default HelpLink;
